export default __webpack_public_path__ + "static/media/FIL.5e7ab80f.svg";